import { InternalOrganizationBillingDetailsType } from '@/api/v1/organization/internal/getInternalOrganizationBillingDetailsApi';
import { getMasterAdminOrganizationDetailsPath } from '@/bundle/_MasterAdmin/path/path';
import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import { ProgressBar } from '@/components/ProgressBar/ProgressBar';
import { INFINITY_SIGN, UNLIMITED_USERS_LIMIT } from '@/const/shared';
import { useNavigate } from 'react-router';

const getMaxUsersLimit = (maxLimit) => {
  return maxLimit === UNLIMITED_USERS_LIMIT ? INFINITY_SIGN : maxLimit;
};

type UsersUsageRowType = {
  billingDetails: InternalOrganizationBillingDetailsType;
};

export const UsersUsageRow = ({ billingDetails }: UsersUsageRowType) => {
  const navigate = useNavigate();

  const { organization, current_plan } = billingDetails;
  const { max_users } = current_plan || {};
  const activeUsers = organization?.active_users_count;
  const maxUsersLimit = getMaxUsersLimit(max_users);

  return (
    <Box width='100%' display='flex' alignItems='center' columnGap='16px'>
      <ProgressBar label='Users' count={activeUsers} totalCount={maxUsersLimit} />
      <Box flexShrink={0}>
        <Button
          variant='secondary'
          size='medium'
          onClick={() => navigate(getMasterAdminOrganizationDetailsPath())}
          mobileStretch
          width='110px'
        >
          View Details
        </Button>
      </Box>
    </Box>
  );
};
